import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AppRoutingModule } from './app-routing.module';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { MatSidenavModule } from '@angular/material/sidenav';

import { AppClientBootstrapService, AppClientProductModule, AppClientRootModule, CUSTOM_DATE_FORMAT, TmcCustomDateAdapter } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { ProductConfigurationModule } from 'src/productconfig/product-config.module';

export function tmcInitializerFactory(service: AppClientBootstrapService) {
  return (): Promise<any> => {
    return service.initializeStart();
  };
}

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSidenavModule,
    AppRoutingModule,
    AppClientRootModule.forRoot(environment),
    ProductConfigurationModule,

    AppClientProductModule
    // CommonProductModule
  ],
  exports: [
  ],
  providers: [

    {
      // see http://www.learn-angular.fr/how-to-call-an-asynchronous-service-before-bootstrap/
      provide: APP_INITIALIZER,
      useFactory: tmcInitializerFactory,
      deps: [AppClientBootstrapService],
      multi: true
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { autoFocus: true, disableClose: true, hasBackdrop: true } },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'de' },
    { provide: DateAdapter, useClass: TmcCustomDateAdapter }

  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
